
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M10 5.313S8.125 8.75 5.625 8.75a11.71 11.71 0 01-3.875-.78"}}),_c('path',{attrs:{"d":"M1.078 6.964A8.605 8.605 0 015 4.374c2.167-.54 4.326.79 4.87 1.16M6.937 8.442c.385 1.53.574 3.105.563 4.683 0 4.54-3.662 4.942-3.662 4.942"}}),_c('path',{attrs:{"d":"M10 19.375c4.375 0 8.75-2.5 8.75-2.5 0-3.125-2.5-3.75-2.5-5.625s3.125-3.438 3.125-5.938A4.745 4.745 0 0014.687.625 4.687 4.687 0 0010 5.311v.002A4.687 4.687 0 005.314.625h-.002A4.745 4.745 0 00.625 5.313c0 2.5 3.125 4.062 3.125 5.937s-2.5 2.5-2.5 5.625c0 0 4.375 2.5 8.75 2.5z"}}),_c('path',{attrs:{"d":"M10 5.313s1.875 3.437 4.375 3.437a11.71 11.71 0 003.875-.78"}}),_c('path',{attrs:{"d":"M18.922 6.964A8.61 8.61 0 0015 4.374c-2.167-.54-4.326.79-4.87 1.16m2.933 2.908a18.717 18.717 0 00-.563 4.683c0 4.542 3.667 4.942 3.667 4.942M9.688 11.25a.313.313 0 11.625 0 .313.313 0 01-.626 0m.001 4.375a.313.313 0 11.625 0 .313.313 0 01-.626 0"}})])])
          )
        }
      }
    